import React, { useState, useEffect, useRef } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet';
import leaflet from 'leaflet';
import 'leaflet/dist/leaflet.css';

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = leaflet.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
leaflet.Marker.prototype.options.icon = DefaultIcon;

function MapaDesembarque({ passagem, destino, tipo }) {
    const mapRef = useRef(null);
    const [position, setPosition] = useState([-15.7942, -47.8821]);

    useEffect(() => {        
        if (passagem && passagem.latitudeDestino && passagem.longitudeDestino) {            
            const lat = tipo === 'origem' ? Number(passagem.longitudeOrigem) : Number(passagem.longitudeDestino);
            const lng = tipo === 'origem' ? Number(passagem.latitudeOrigem) : Number(passagem.latitudeDestino);
            
            if (!isNaN(lat) && !isNaN(lng)) {
                setPosition([lat, lng]);
                
                if (mapRef.current) {
                    const leafletMap = mapRef.current.leafletElement;

                    setTimeout(() => {
                        leafletMap.invalidateSize();
                        leafletMap.setView([lat, lng], 15);
                    }, 200);
                }

            }
        }
    }, [passagem]);

    return (
        <div className="form-row">
            <div className="col-12">
                <div className='renderMapa'>
                    <Map 
                        ref={mapRef}
                        center={position} 
                        zoom={15} 
                        style={{ height: '100%', width: '100%' }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; OpenStreetMap contributors'
                        />
                        <Marker position={position}>
                            <Popup>
                                Local de Desembarque: <br /> 
                                {destino.nome} - {destino.uf}
                            </Popup>
                        </Marker>
                    </Map>
                </div>
            </div>
        </div>
    );
}

export { MapaDesembarque };